import { exists } from "../utils";

let string_identifiers: {[key:string]:String_id} = {};
let numeric_identifiers: {[key:number]:Numeric_id} = {};

class String_id {
    private _value: string;
    protected constructor(val: string) { this._value = val; }
    public toString(): string { return this._value; }
    public get value(): string { return this._value; }
    public equals(rhs: String_id | string): boolean {
        if (rhs instanceof String_id) {
            return this.value === rhs._value;
        }
        if (typeof (rhs) === typeof ("")) {
            return this.value === rhs;
        }
        return false;
    }
    public toJSON(): any {
        return this.value;
    }
    protected static wrap(id:string):String_id{
        if(string_identifiers[id]==null){
            string_identifiers[id]=new String_id(id);
        }        
        return string_identifiers[id];
    }
}


function to_number(val: number | string): number | null {
    let r: number = null;
    if (val === null) {
        return null;
    }
    if (val === undefined) {
        return null;
    }
    if (typeof (val) === typeof (123)) {
        return <number>val;
    }
    if (typeof (val) === typeof ("")) {
        r = parseInt(<string>val);
        if (isNaN(r)) {
            return null;
        }
        return r;
    }
    return null;
}


class Numeric_id {
    private _value: number;
    protected constructor(val: number | string) {
        if (typeof (val) === typeof ("")) {
            this._value = parseInt(<string>val);
        }
        else {
            this._value = <number>val;
        }
    }
    public toString(): string { return this._value.toString(); }
    public get value(): number { return this._value; }

    public equals(rhs: Numeric_id | number): boolean {
        if (rhs instanceof Numeric_id) {
            return this.value === rhs._value;
        }
        if (typeof (rhs) === typeof (123)) {
            return this.value === rhs;
        }
        return false;
    }
    public toJSON(): any {
        return this.value;
    }
    protected static wrap(id:number|string):Numeric_id{
        let temp: number = to_number(id);
        if (!temp) {
            return null;
        }

        if(numeric_identifiers[temp]==null){
            numeric_identifiers[temp]=new Numeric_id(temp);
        }        
        return numeric_identifiers[temp];
    }
}


export class Id_asset extends String_id {
    public static wrap(val: string): Id_asset {
        if (!val) {
            return null;
        }
        return <Id_asset>(String_id.wrap(val));
    }
}


export class Id_attachment extends String_id {
    public static wrap(val: string): Id_attachment {
        if (!val) {
            return null;
        }
        return new Id_attachment(val);
    }
}


export class Id_building extends Numeric_id {
    public static wrap(val: number | string): Id_building {
        return Numeric_id.wrap(val);
        // let temp: number = to_number(val);
        // if (!temp) {
        //     return null
        // }
        // return new Id_building(temp);
    }
}

export class Id_category extends Numeric_id {
    public static wrap(val: number | string): Id_category {
        return Numeric_id.wrap(val);
        // let temp: number = to_number(val);
        // if (!temp) {
        //     return null
        // }
        // return new Id_category(temp);
    }
}


export class Id_drawing extends String_id {
    public static wrap(val: string): Id_drawing {
        if (!val) {
            return null;
        }
        return <Id_drawing>(String_id.wrap(val));

    }
}

export class Id_finding extends String_id {
    public static wrap(val: string): Id_finding {
        if (!val) {
            return null;
        }
        return <Id_finding>String_id.wrap(val);
    }
}

export class Id_workorder_category extends String_id {   // AWH TODO: this needs to become a numeric id. it's currently just wrapping the category label from the menu, which is very brittle.
    public static wrap(val: string|Id_workorder_category): Id_finding {
        if (!exists(val)) {
            return null;
        }
        if (val instanceof Id_workorder_category) {
            return val;
        }
        return <Id_workorder_category>String_id.wrap(val);
    }
}


export class Id_floor extends Numeric_id {
    public static wrap(val: number | string): Id_floor {
        let temp: number = to_number(val);
        if (!temp) {
            return null;
        }
        return <Id_floor>Numeric_id.wrap(temp);
    }
}

export class Id_location extends Numeric_id {

    public static wrap(val: number | string): Id_location {
        return <Id_location>Numeric_id.wrap(val);
    }
}

export class Id_workorder extends String_id {
    public static wrap(val: string): Id_workorder {
        if (!val) {
            return null;
        }
        return <Id_workorder>(String_id.wrap(val));

    }
}

export class Id_workorder_asset extends String_id {
    public static wrap(val: string): Id_workorder_asset{
        if (!val){
            return null;
        }
        return <Id_workorder_asset>(String_id.wrap(val));
    }
}

export class Id_collection {

    private _ids: string[] = [];

    public add(id: Numeric_id | String_id): Id_collection {
        if (!id) {
            return this;
        }
        this._ids.push(id.toString());
        return this;
    }

    public includes(id: Numeric_id | String_id): boolean {
        if(!id){
            return false;
        }
        return this._ids.includes(id.toString());
    }

    public toJson(): string[] {
        return this._ids;
    }

    public static fromJson(vals: string[]): Id_collection {
        let r: Id_collection = new Id_collection();
        r._ids = Object.assign([], vals);
        return r;
    }
}

// helper functions
export function id_category_list_to_string(cats:Id_category[]):string[]{
    let temp:Set<string> = new Set<string>();
    cats.forEach((id:Id_category)=>{
        if(id){
            temp.add(id.toString());
        }
    });
    return Array.from(temp);
}

export function id_category_list_from_string(cats:string[]):Id_category[]{
    return cats.map((cat:string)=>{ return Id_category.wrap(cat);});
}